import React from 'react';

import '../../CSS/Newsletter.css';

const Newsletter = () => (
  <div className="container py-10 px-5 w-full mx-auto">
    <div className="border flex flex-col md:flex-row gap-3 mx-auto w-full border-dotted rounded space-y-2 bg-[#FDF6EC] border-[#F5C332] py-10 p-7">
      <div className="mx-auto w-full">
        <img draggable="false" style={{animation: `revercespin 60s linear infinite`,transform: `rotate(${Math.floor(Math.random() * (361))}deg)`}} src="https://www.freepnglogos.com/uploads/food-png/food-grass-fed-beef-foodservice-products-grass-run-farms-4.png" alt="" className="object-cover" />
      </div>
      <div className="w-full mx-auto">
        <h1 className="text-3xl md:text-6xl font-bold fw-bold text-center capitalize" style={{ fontFamily: "Rajdhani" }}>Subscribe for <span className="">KhaDok</span> Offer</h1>
        <p className="text-gray-500 text-center">Please join our exclusinve and private member group where we offer exciting khadok offer every week. <br /> So don't miss it and subscribe now for your next offer.</p>
        <div className="app__newsletter-input flex__center flex items-center justify-center">
          <input type="email" placeholder="Enter your email address" />
          <button type="button" className="bg-[#F5C332] px-7 text-md font-semibold py-4 rounded">Subscribe</button>
        </div>
        <p className="text-gray-400 text-center pt-5">We hate spam and your email protected by us!</p>
      </div>
    </div>
  </div>
);

export default Newsletter;
